var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.withCommonFooter)?_c('div',{class:[
        'footer-container',
        _vm.langText,
        {
            'client-skin-adapt': _vm.isSkinAuto,
            dark: _vm.isSkinDark,
            pc: _vm.isPC,
        }
    ]},[_c('div',{class:['footer-logo', _vm.logo],style:(_vm.logoStyle)}),_vm._v(" "),(_vm.title)?_c('div',{staticClass:"footer-title",domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),(_vm.text)?_c('div',{staticClass:"footer-text",domProps:{"innerHTML":_vm._s(_vm.text)}}):_vm._e(),_vm._v(" "),(_vm.copyright)?_c('div',{staticClass:"footer-copyright",domProps:{"innerHTML":_vm._s(_vm.copyright)}}):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }